import React from 'react';
import {Tabs} from "antd";
import WrinklesAnalysisComponent from "./wrinkles_analysis.component";
import {useTranslation} from "react-i18next";
import AcneAnalysisComponent from "./acne_analysis.component";

const AnalysisResultsComponent = ({
                                      analysis,
                                      hideImages = false,
                                      hideTabs = false,
                                      activeAnalysisType = null,
                                      hideProgressBars = false
                                  }) => {
    const {t} = useTranslation("common");
    const [allWrinkles, setAllWrinkles] = React.useState([]);
    const [allAcne, setAllAcne] = React.useState([]);
    const [activeKey, setActiveKey] = React.useState('1');

    const getWrinklesAnalysis = () => {
        if (analysis?.analyses && analysis.analyses.length > 0) {
            return analysis.analyses.find(item => item.analysis_type === 1);
        }
        return null;
    };

    const getByType = (type) => {
        if (analysis?.analyses && analysis.analyses.length > 0) {
            // Filter analyses by type and sort by date
            analysis.analyses.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            return analysis.analyses.filter(item => item.analysis_type === type).map(item => {
                return {
                    ...item,
                    date: new Date(item.created_at),
                    wrinkles: getWrinklesAnalysis()
                };
            });
        }
        return null;
    };

    const onChange = key => {
        setActiveKey(key);
    };

    const items = [
        {
            key: '1',
            label: t('wrinkles_analysis'),
            children: (<WrinklesAnalysisComponent wrinkles={allWrinkles} analysis={analysis} hideImages={hideImages}/>),
        },
        {
            key: '2',
            label: t('acne_analysis'),
            children: (<AcneAnalysisComponent acnes={allAcne} analysis={analysis} hideImages={hideImages}
                                              hideProgressBars={hideProgressBars}/>),
        },
    ];

    React.useEffect(() => {
        setAllWrinkles(getByType(1));
        setAllAcne(getByType(2));
    }, [analysis]);

    // Sync activeKey with activeAnalysisType prop
    React.useEffect(() => {
        if (activeAnalysisType !== null) {
            setActiveKey(activeAnalysisType.toString());
        }
    }, [activeAnalysisType]);

    // If hideTabs is true and activeAnalysisType is set, render only that component
    if (hideTabs && activeAnalysisType !== null) {
        const activeItem = items.find(item => item.key === activeAnalysisType.toString());
        if (activeItem) {
            return (
                <div style={{maxHeight: 'calc(100vh - 200px)', overflowY: 'auto'}}>
                    {activeItem.children}
                </div>
            );
        }
    }

    // If hideTabs is true but no activeAnalysisType, don't show anything
    if (hideTabs && activeAnalysisType === null) {
        return null;
    }

    return (
        <div style={{maxHeight: 'calc(100vh - 200px)', overflowY: 'auto'}}>
            <Tabs activeKey={activeKey} items={items} onChange={onChange}/>
        </div>
    );
};

export default AnalysisResultsComponent;